import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'follow', es);
i18next.addResourceBundle('en', 'follow', en);
i18next.addResourceBundle('pt', 'follow', pt);